import { replyToEmailTypes } from './constants'

const transformCCEmails = ccEmails => {
  return ccEmails?.map(email => email.trim())?.filter(email => email !== '') || []
}

export const getPayload = ({
  replyToEmail,
  replyToEmailType,
  notificationTypes,
  defaultEmail,
  language,
  billingEmail,
  billingCcEmails,
}) => {
  const payload = {
    reply_to_type: replyToEmailType,
    reply_to_email: [replyToEmailTypes.reveni_email, replyToEmailTypes.store_contact_email].includes(replyToEmailType)
      ? null
      : replyToEmail,
    language,
    notification_types: notificationTypes?.map(notificationType => ({
      ...notificationType,
      email: notificationType?.email === defaultEmail || notificationType?.email === '' ? null : notificationType.email,
      cc_emails: transformCCEmails(notificationType?.cc_emails),
    })),
    billing_email: billingEmail,
    billing_cc_emails: transformCCEmails(billingCcEmails),
  }

  return payload
}

export const isNotificationEnabled = (identifier, notifications) => {
  const notification = notifications?.find(notification => notification.identifier === identifier)

  return notification?.email_enabled
}

export const getRecipientEmail = (identifier, notifications, defaultEmail) => {
  const notification = notifications?.find(notification => notification.identifier === identifier)

  if (notification && notification?.email === null) {
    notification.email = defaultEmail
  }

  return notification?.email
}

export const getCcEmails = (identifier, notifications) => {
  const notification = notifications?.find(notification => notification.identifier === identifier)

  return notification?.cc_emails
}

export const filterReplyToOptionsBySubscriptionPlan = (options, subscriptionPlan) => {
  return options.filter(option => option.availableFor.includes(subscriptionPlan))
}
